import Phaser from "phaser";
import LoadingScene from "@/games/CookingTutorial/scenes/LoadingScene";
import QuestionScene from "@/games/CookingTutorial/scenes/QuestionScene";
import PlayScene from "@/games/CookingTutorial/scenes/PlayScene";
import AnsCorrectPlayScene from "@/games/CookingTutorial/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/games/CookingTutorial/scenes/AnsWrongPlayScene";
import Settings from "@/games/CookingTutorial/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      Settings,
    ],
  });
}

export default launch;
export { launch };
